<template>
  <v-row class="fill-height">
    <v-col cols="12" lg="12"
           class="d-flex justify-center align-start fill-height mx-auto pa-10">
      <v-card
          tile
          :flat="tickets.length === 0"
          class="mx-auto nitg__width-100 pa-0"
      >
        <template v-if="tickets.length > 0">
          <v-card-text class="pa-0">
            <v-list class="pa-0">
              <v-list-item-group v-model="list.id">
                <v-list-item
                    @click="watchEmail(item)"
                    v-for="(item, i) in pages"
                    :key="i"
                >
                  <v-list-item-icon>
                    <v-badge offset-x="10"
                             offset-y="10"
                             color="info"
                             :content="item.unread"
                             v-if="item.unread > 0">
                      <v-icon>mdi-mail</v-icon>
                    </v-badge>
                    <v-icon v-else>mdi-mail</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.subject }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <template v-if="tickets.length > perPage">
            <v-card-actions>
              <v-spacer/>
              <v-pagination
                  v-model="page"
                  class="rounded-0"
                  :length="length"
                  :total-visible="totalVisible"
              ></v-pagination>
              <v-spacer/>
            </v-card-actions>
          </template>
        </template>
        <template v-else>
          <v-card-text class="text-h5">
            <span>You have no messages</span>
          </v-card-text>
        </template>
      </v-card>
    </v-col>
    <v-dialog v-model="show.mail"
              scrollable
              content-class="white rounded-0"
              :max-width="$vuetify.breakpoint.width / 1.2">
      <v-card v-if="show.mail" flat tile max-height="500">
        <v-card-title class="elevation-1 pr-3 pl-3" style="z-index: 2">
          <p class="mb-0">{{ email.subject }}</p>
          <v-spacer/>
          <v-btn icon color="primary" dark @click="closeMails">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" style="max-height: 400px">
          <v-row class="ma-0 pa-0">
            <v-col :cols="email.messages.length > 0 ? 6 : 12" class="nitg__position-relative"
                   style="border-right: 2px solid rgba(0, 0, 0, 0.12);">
              <p class="nitg__position-fixed" style="display: contents">{{ email.question }}</p>
              <div v-if="attachments && Object.keys(attachments).length > 0" class="d-flex justify-start align-center flex-wrap">
                <div class="ma-0 pa-0" v-for="(attachment, key) in attachments" :key="key">
                  <template v-for="attach in attachment">
                    <v-btn :key="attach.name" width="100" height="100"
                           class="mt-3 mb-3 mr-3 elevation-0 pa-0"
                           tile
                           dark
                           @click="openPreview(attach.name)"
                           v-if="fileCheck(attach.name)" color="white">
                      <v-icon size="100"
                              color="primary" dark>mdi-file-image-outline
                        <small class="text--primary">
                          <strong>
                            {{ attach.name }}
                          </strong>
                        </small>
                      </v-icon>
                    </v-btn>
                    <v-btn :key="attach.id" width="100" height="100"
                           class="mt-3 mb-3 mr-3 elevation-0 pa-0"
                           tile
                           dark
                           @click="downloadAttachment(attach.name)"
                           v-if="!fileCheck(attach.name)" color="white">
                      <v-icon size="100"
                              color="primary"
                              v-if="attach.name.split('.').pop() === 'docx' || attach.name.split('.').pop() === 'doc'">mdi-file-word-outline</v-icon>
                      <v-icon size="100"
                              color="primary"
                              v-if="attach.name.split('.').pop() === 'pptx' || attach.name.split('.').pop() === 'ppt'">mdi-file-powerpoint-outline</v-icon>
                      <v-icon size="100"
                              color="primary"
                              v-if="attach.name.split('.').pop() === 'pdf'" dark>mdi-file-pdf-outline</v-icon>
                      <v-icon size="100"
                              color="primary"
                              v-if="attach.name.split('.').pop() === 'xlsx' || attach.name.split('.').pop() === 'xls'">mdi-file-excel-outline</v-icon>
                    </v-btn>
                  </template>
                </div>
              </div>
            </v-col>
            <v-col v-if="email.messages.length > 0" :cols="email.messages.length > 0 ? 6 : 12" class="pa-0">
              <v-timeline dense>
                <v-hover class="ma-0 pa-0" v-slot:default="{ hover }" v-for="(mail) in email.messages" :key="mail.id">
                  <v-timeline-item
                      color="white"
                      fill-dot>
                    <template v-slot:icon>
                      <v-icon v-text="mail.status ? 'mdi-check-circle-outline' : 'mdi-checkbox-blank-circle'" size="24" color="primary"></v-icon>
                    </template>
                    <v-row @mouseenter="readMessage(mail)" class="ma-0 pa-0">
                      <v-col class="ma-0 pa-0" cols="9">
                        <v-card-title>{{ mail.user }}</v-card-title>
                        <v-card-subtitle>{{ mail.created_at }}</v-card-subtitle>
                        <v-card-text v-html="mail.message">{{ mail.message }}</v-card-text>
                      </v-col>
                      <transition enter-active-class="animate__animated animate__fadeIn animate__faster"
                                  leave-active-class="animate__animated animate__fadeOut animate__faster">
                        <v-col v-if="hover" class="d-flex align-center justify-center ma-0 pa-0" cols="3">
                          <v-card-actions class="ma-0 pa-0">
                            <v-btn @click="answer(mail.id)" text tile>{{ $t('dialog.answer') }}</v-btn>
                          </v-card-actions>
                        </v-col>
                      </transition>
                    </v-row>
                  </v-timeline-item>
                </v-hover>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="elevation-3">
          <v-spacer/>
          <v-btn tile text @click="closeMails">
            {{ email.mails && email.mails.length > 1 ? $t('dialog.closeChain')  : $t('dialog.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog content-class="white rounded-0"
              scrollable
              :max-width="$vuetify.breakpoint.width / 1.2" v-model="show.answer">
      <v-card flat tile class="nitg__position-relative">
        <v-card-title class="elevation-1 pr-3 pl-3" style="z-index: 2">
          <p class="mb-0">Answer to email</p>
          <v-spacer/>
          <v-btn icon @click="closeAnswer">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" :style="`max-height: ${$vuetify.breakpoint.height / 1.4}px`">
          <tiptap-vuetify
              :card-props="{ tile: true, height: ($vuetify.breakpoint.height / 1.2) }"
              v-model="form.message" :extensions="extensions" placeholder="Write your answer here"/>
        </v-card-text>
        <v-card-actions class="elevation-3" style="z-index: 2">
          <v-spacer/>
          <v-btn tile text @click="sendAnswer">
            Отправить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div @hidden="closePreview" id="previewed" v-viewer="options">
      <img :src="preview" :alt="preview">
    </div>
  </v-row>
</template>

<script>
import _ from 'lodash'
import {
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from 'tiptap-vuetify'
export default {
  name: "Inbox",
  data () {
    return {
      preview: null,
      options: {
        "inline": false,
        "button": true,
        "navbar": true,
        "toolbar": {
            "zoomIn": true,
            "zoomOut": true,
            "oneToOne": true,
            "reset": true,
            "prev": false,
            "play": false,
            "next": false,
            "rotateLeft": true,
            "rotateRight": true,
            "flipHorizontal": true,
            "flipVertical": true,
        },
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true
      },
      form: {
        message: ''
      },
      list: {},
      email: {},
      show: {
        mail: false,
        answer: false
      },
      page: 1,
      perPage: 10,
      totalVisible: 5,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3, 4, 5, 6]
          }
        }],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
      ticketID: null
    }
  },
  mounted () {
    this.getTickets()
  },
  methods: {
    readMessage (mail) {
      if (!mail.status) {
        mail.status = true
        this.$http.patch(`api/v2/auth/read/${mail.id}`)
            .then((response) => {
              this.$store.dispatch('setMails', response.data.tickets);
              this.$root.$emit('get-unread')
            })
      }

    },
    watchEmail (email) {
      this.email = email
      this.show.mail = true
    },
    closeMails () {
      this.show.mail = false
      this.email = {}
    },
    getTickets () {
      this.$store.dispatch('setLoading', true);
      this.$http.get('api/v2/auth/tickets')
          .then((response) => {
            this.$store.dispatch('setMails', response.data.tickets);
          })
          .finally(() => {
            this.$store.dispatch('setLoading', false);
          })
    },
    answer (id) {
      this.show.answer = true
      this.ticketID = id
    },
    sendAnswer () {
      this.$http.post('api/v2/auth/answer', this.form, {
        headers: {
          'X-Mail-ID': this.ticketID,
          'X-Ticket-ID': this.email.id
        }
      })
          .then((response) => {
            this.$http.get('api/v2/auth/run')
            this.$store.dispatch('setMails', response.data.tickets);
            this.show = {
              mail: false,
              answer: false
            }
            this.ticketID = null
            this.email = {}
          })
    },
    closeAnswer () {
      this.show.answer = false
    },
    fileCheck (path){
      const checker = require('is-image')
      return checker(path)
    },
    downloadAttachment (link) {
      window.open(link, '_blank')
    },
    openPreview (src) {
      this.show.mail = false
      const viewer = this.$el.querySelector('#previewed').$viewer
      this.preview = src
      viewer.show()
    },
    closePreview () {
      this.preview = null
    },
    downloadImage () {
      window.open(this.preview.src, '_blank')
    }
  },
  computed: {
    tickets () {
      return this.$store.getters.GET_MAILS
    },
    length () {
      return this.perPage ? Math.ceil(this.tickets.length / this.perPage) : 0
    },
    pages () {
      return this.tickets.slice((this.page - 1) * this.perPage, this.page * this.perPage)
    },
    attachments () {
      return _.groupBy(this.email.attachments, 'extension')
    }
  }
}
</script>
